import marcaBlancaServices from 'legacyfrontend/api/services/marcaBlancaServices';
import { SET_SECTION_ERROR, SET_SECTION } from './action-types';

export const getCustomSection = (id) => async (dispatch, getState) => {
  try {
    const response = await marcaBlancaServices.getCustomSection(id);
    return dispatch({
      type: SET_SECTION,
      payload: response,
    });
  } catch (error) {
    return dispatch({ type: SET_SECTION_ERROR });
  }
};

export const getDefaultSection = (id) => async (dispatch, getState) => {
  try {
    const response = await marcaBlancaServices.getDefaultSection(id);
    return dispatch({
      type: SET_SECTION,
      payload: response,
    });
  } catch (error) {
    return dispatch({ type: SET_SECTION_ERROR });
  }
};
